import { Fragment, type CSSProperties } from "react";
import { Icons } from "./Icons.js";

/**
 * Gros bouton d'enregistrement (porté du mockup). L'effet visuel « anneaux » s'affiche pendant
 * l'enregistrement. La logique tap-vs-maintien est gérée par l'appelant via les gestionnaires de
 * pointeur ; ici on ne rend que l'apparence.
 */
export interface RecordButtonProps {
  recording: boolean;
  level?: number;
  scale?: number;
  onPointerDown?: () => void;
  onPointerUp?: () => void;
}

export function RecordButton({ recording, level = 0, scale = 1, onPointerDown, onPointerUp }: RecordButtonProps) {
  const base = 132 * scale;
  return (
    <div className="recwrap" style={{ "--lvl": level } as CSSProperties}>
      {recording && (
        <Fragment>
          <span className="ring ring1" />
          <span className="ring ring2" />
          <span className="ring ring3" />
        </Fragment>
      )}
      <button
        className={"recbtn" + (recording ? " rec" : "")}
        style={{ width: base, height: base }}
        onPointerDown={onPointerDown}
        onPointerUp={onPointerUp}
        onPointerLeave={onPointerUp}
        // Complément au CSS : sur iOS, l'appui long ouvrirait le menu contextuel et annulerait le
        // geste de maintien (mode talkie-walkie). On refuse l'événement plutôt que de perdre le geste.
        onContextMenu={(e) => e.preventDefault()}
        aria-pressed={recording}
        aria-label={recording ? "Arrêter l'enregistrement" : "Démarrer l'enregistrement"}
      >
        <span className="recicon" style={{ color: "var(--onAccent)" }}>
          {recording ? <Icons.Stop size={Math.round(40 * scale)} /> : <Icons.Mic size={Math.round(46 * scale)} sw={2} />}
        </span>
      </button>
    </div>
  );
}
